import {
  EGroupsChangesActions,
  GroupsChangesActions,
} from '@myStore/groups-changes/groups-changes.actions';
import {
  IGroupsChangesState,
  initialGroupsChangesState,
} from '@myStore/groups-changes/groups-changes.state';

export const groupsChangesReducers = (
  state = initialGroupsChangesState,
  actions: GroupsChangesActions
): IGroupsChangesState => {
  switch (actions.type) {
    case EGroupsChangesActions.AddAdminsToTGGroupRequest:
      return {
        ...state,
        telegramGroup: {
          isLoading: true,
          success: false,
          errors: null,
        },
      };
    case EGroupsChangesActions.AddAdminsToTGGroupSuccess:
      return {
        ...state,
        telegramGroup: {
          isLoading: false,
          success: true,
          errors: null,
        },
      };
    case EGroupsChangesActions.AddAdminsToTGGroupFailure:
      return {
        ...state,
        telegramGroup: {
          isLoading: false,
          success: false,
          errors: actions.errors,
        },
      };
    case EGroupsChangesActions.ClearAddAdminsToTGGroupErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
      };

    case EGroupsChangesActions.SendCreateGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.SendCreateGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SendCreateGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearCreateGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EGroupsChangesActions.SendUpdateGroupRequest:
      return {
        ...state,
        success: false,
        isLoading: true,
      };
    case EGroupsChangesActions.SendUpdateGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SendUpdateGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearUpdateGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EGroupsChangesActions.DeleteGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.DeleteGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.DeleteGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearDeleteGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EGroupsChangesActions.SendDeactivateGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.SendDeactivateGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SendDeactivateGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearDeactivateGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EGroupsChangesActions.ActivateGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.ActivateGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.ActivateGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearActivateGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EGroupsChangesActions.SendTransfersStudentsToGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.SendTransfersStudentsToGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SendTransfersStudentsToGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearTransfersStudentsToGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EGroupsChangesActions.SendAddStudentsToGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.SendAddStudentsToGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SendAddStudentsToGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearAddStudentsToGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EGroupsChangesActions.SendAddTeachersToGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.SendAddTeachersToGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SendAddTeachersToGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearAddTeachersToGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EGroupsChangesActions.SendStudentDropoutFromGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.SendStudentDropoutFromGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SendStudentDropoutFromGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearStudentDropoutFromGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EGroupsChangesActions.SendActivateStudentToGroupRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.SendActivateStudentToGroupSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SendActivateStudentToGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearActivateStudentToGroupErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EGroupsChangesActions.SetStudentOnlineRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.SetStudentOnlineSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.SetStudentOnlineFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearSetStudentOnlineErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EGroupsChangesActions.DeleteTeacherRequest:
    case EGroupsChangesActions.DeleteTeacherFromSelectedGroupsRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.DeleteTeacherSuccess:
    case EGroupsChangesActions.DeleteTeacherFromSelectedGroupsSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.DeleteTeacherFailure:
    case EGroupsChangesActions.DeleteTeacherFromSelectedGroupsFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearDeleteTeacherErrors:
    case EGroupsChangesActions.ClearDeleteTeacherFromSelectedGroups:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EGroupsChangesActions.EditStudentAccessRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsChangesActions.EditStudentAccessSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EGroupsChangesActions.EditStudentAccessFailure:
      return {
        ...state,
        success: false,
        isLoading: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearEditStudentAccess:
      return {
        ...state,
        success: false,
        isLoading: false,
        errors: null,
      };

    case EGroupsChangesActions.TransferToESDPRequest:
      return { ...state, isLoading: true };
    case EGroupsChangesActions.TransferToESDPSuccess:
      return { ...state, success: true, isLoading: false };
    case EGroupsChangesActions.TransferToESDPFailure:
      return {
        ...state,
        success: false,
        isLoading: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearTransferToESDP:
      return {
        ...state,
        success: false,
        isLoading: false,
        errors: null,
      };
    case EGroupsChangesActions.ReturnTeacherRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case EGroupsChangesActions.ReturnTeacherSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EGroupsChangesActions.ReturnTeacherFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearReturnTeacher:
      return {
        ...state,
        isLoading: false,
        success: false,
      };

    case EGroupsChangesActions.AddCheckingTeacherRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case EGroupsChangesActions.AddCheckingTeacherSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EGroupsChangesActions.AddCheckingTeacherFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearAddCheckingTeacherErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
      };

    case EGroupsChangesActions.DeleteCheckingTeacherRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case EGroupsChangesActions.DeleteCheckingTeacherSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EGroupsChangesActions.DeleteCheckingTeacherFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearDeleteCheckingTeacherErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
      };

    case EGroupsChangesActions.RefreshCheckingTeacherHomeworksRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case EGroupsChangesActions.RefreshCheckingTeacherHomeworksSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EGroupsChangesActions.RefreshCheckingTeacherHomeworksFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EGroupsChangesActions.ClearRefreshCheckingTeacherHomeworksErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
      };

    case EGroupsChangesActions.StudentHappyPointAllowedRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case EGroupsChangesActions.StudentHappyPointAllowedSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EGroupsChangesActions.StudentHappyPointAllowedFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    case EGroupsChangesActions.ClearStudentHappyPointAllowed:
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    case EGroupsChangesActions.DeleteTeacherFromGroupRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case EGroupsChangesActions.DeleteTeacherFromGroupSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EGroupsChangesActions.DeleteTeacherFromGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    case EGroupsChangesActions.ChangeAttentionESDPGroupTrue:
      return {
        ...state,
        attentionESDPGroup: true,
      };
    case EGroupsChangesActions.ChangeAttentionESDPGroupFalse:
      return {
        ...state,
        attentionESDPGroup: false,
      };
    default:
      return state;
  }
};
